import React, { Fragment } from 'react'
import { connect } from "react-redux";
import Moment from "react-moment"
import { Elements } from 'react-stripe-elements';
import NavigationTabs from '../nav/NavigationTabs';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import YouTubeVideoPreview from './../YouVideoPreview'
import { getGateWayDashBoardLink } from "../../store/actions/payments"
import { COLORS } from '../../styles/colors';
import withAuth from '../../hocs/withAuth';
import AlertMessage from '../AlertMessage';
import PaymentMethod from './PaymentMethod';
import { fetchUser } from "../../store/actions/auth"
import CancelSubscription from './CancelSubscription';
import { STRIPE_USER,  STRIPE_HELP_VIDEO_LINK } from './../../constants';

class Billing extends React.Component {
  state = {
    dataLoaded: false,
    showPaymentMethods: false,
    showCancelSubscriptionModal: false,
    isOpen:false
  }

  /**
   * @description redirectToPaymentGateWay method to redirect the payment gateway
   */
  redirectToPaymentGateWay = () => {
    const redirectUrl = `${process.env.REACT_APP_URL}/successConnection?next=settings`;
    const clientId = process.env.REACT_APP_STRIPE_CLIENT_ID;
    const pathArr = [
      process.env.REACT_APP_STRIPE_AUTH_URL,
      `redirect_uri=${redirectUrl}`,
      `scope=read_write`,
      `client_id=${clientId}`,
    ];
    window.location.href = `${pathArr.join('&')}&${STRIPE_USER}`;
  }

  /**
   * @description
   * createPaymentGateWayDashBoardLink method is used to create payment gateway dashboard
   */
  createPaymentGateWayDashBoardLink = () => {
    const { getGateWayDashBoardLink } = this.props;
    getGateWayDashBoardLink().then((response) => {
      if (response.data && response.data.url) {
        window.open(response.data.url);
      }
    });
  }

  componentDidMount() {
    const { fetchUser } = this.props;
    fetchUser();
    this.setState({ ...this.state, dataLoaded: true })
  }

  moveToInvoicesPage = () => {
    const { history } = this.props;
    history.push('/settings/invoices');
  }

  updatePaymentCard = () => {
    this.setState({
      showPaymentMethods: true
    })
  }

  hidePaymentMethod = () => {
    this.setState({
      showPaymentMethods: false
    })
  }

  hideCancelSubscriptionModal = () => {
    this.setState({
      showCancelSubscriptionModal: false
    })
  }

  moveToStripeLogin = () => {
    window.open("https://dashboard.stripe.com/login");
  }

  openModal = () => {
    this.setState({ isOpen: true })
  }

  render() {
    const { user, user: { type = [] }, logout } = this.props;
    const { showPaymentMethods, showCancelSubscriptionModal } = this.state;
    return (
      <div>
        <NavigationTabs
          title="Settings"
          set="settings"
          currentUser={this.props.currentUser}
          subtitle="Fitbanx Billing"
          activeRoute="/settings/billing" />
        <YouTubeVideoPreview channel='youtube' isOpen={this.state.isOpen} videoId={STRIPE_HELP_VIDEO_LINK} onClose={() => this.setState({ isOpen: false })} />
        <Table >
          <TableBody>
            {type.includes('trainer') &&
              <TableRow>
                <TableCell align="right">
                  Monthly Plan:
              </TableCell>
                <TableCell align="left">
                  { user.isTrainerPriceChange ? '$39': '$10'} base fee
                <br />
                  <a onClick={() => {
                    this.setState({
                      showCancelSubscriptionModal: true
                    })
                  }} style={{ cursor: 'pointer' }}>Cancel Account</a>
                </TableCell>
              </TableRow>
            }

            {(type.includes('brand') || type.includes('corporate')) && user.planOption !== 0  &&
              <TableRow>
                <TableCell align="right">
                  Monthly Plan:
              </TableCell>
                <TableCell align="left">
                  { user.planOption === 1 ? 
                    '$10 base fee': 
                    user.planOption === 2 ?
                    '$25 base fee' :
                    user.planOption === 3 ?
                    '$49 base fee' :
                    user.planOption === 4 ?
                    '$59 base fee' :
                    user.planOption === 5 ?
                    '$69 base fee' : ''
                  } 
                  <Fragment>
                    <br />
                      <a onClick={() => {
                        this.setState({
                          showCancelSubscriptionModal: true
                        })
                      }} style={{ cursor: 'pointer' }}>Cancel Account</a>
                  </Fragment>
                </TableCell>
              </TableRow>
            }

            <TableRow>
              <TableCell align="right">
                Next Invoice:
              </TableCell>
              <TableCell align="left">
                {user.nextInvoice ?
                  <Moment className="text-muted" format="D MMM YYYY">{user.nextInvoice}</Moment>
                  : 'Soon Updated'
                }
                <br />
                <a onClick={this.moveToInvoicesPage} style={{ cursor: 'pointer' }}>See all invoices</a>
                <br />
                {user && user.customerId &&
                  <a onClick={this.updatePaymentCard} style={{ cursor: 'pointer' }}>Update payment information</a>
                }
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="right">
                Stripe Account:
              </TableCell>
              <TableCell align="left">
                {
                  user && user.stripeAccountId && (
                    <span>{user.stripeEmail}</span>
                  )
                }
                {
                  user && user.stripeAccountId && (
                    <div style={{
                      marginTop: 10
                    }}>
                      <Button
                          variant="contained"
                          color="secondary"
                          onClick={this.moveToStripeLogin}
                          style={{
                            backgroundColor: COLORS.orange
                          }}
                      >
                          LOGIN TO STRIPE ACCOUNT
                      </Button>
                    </div>
                  )
                }
                {user && !user.stripeAccountId &&
                  <div>
                    <AlertMessage
                      subject="Notice"
                      body="You do not have a linked stripe account. Please click the Connect with Stripe button to get paid."
                      icon='exclamation-circle'
                    />
                    <span>Please watch this important  <span style={{
                      color: COLORS.orange,
                      fontSize: '16px',
                      fontWeight: 'bold'
                    }}><a onClick={this.openModal}>VIDEO</a></span> before connecting to Stripe.
                  </span>
                    <span id='cwppButton' style={{
                      marginTop: 10,
                      display: 'block'
                    }}>
                      <a class="stripe-connect" onClick={this.redirectToPaymentGateWay}><span>Connect with Stripe</span></a>
                    </span>
                  </div>
                }
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        {showPaymentMethods && <Elements><PaymentMethod {...this.props} show={showPaymentMethods} hidePaymentMethod={this.hidePaymentMethod} /></Elements>}
        {showCancelSubscriptionModal && <CancelSubscription show={showCancelSubscriptionModal} logout={logout} hideCancelSubscriptionModal={this.hideCancelSubscriptionModal} />}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.currentUser.user,
    payments: []
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getGateWayDashBoardLink: () => {
      return dispatch(getGateWayDashBoardLink());
    },
    fetchUser: () => {
      return dispatch(fetchUser());
    }
  }
}

export default withAuth(connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Billing));



// WEBPACK FOOTER //
// ./src/components/settings/Billing.js